import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  RemoveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {EmojiListProps} from 'Event/template/SimpleBlog/Dashboard/Sidebar/SidebarItem/EmojiList'
import {
  useAutoUpdateSidebarItem,
  useEditSidebarItem,
} from 'Event/template/SimpleBlog/Dashboard/Sidebar/SidebarItem'
import Settings from 'Event/template/SimpleBlog/Dashboard/Sidebar/SidebarItem/EmojiList/EmojiListConfig/Settings'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import RulesPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/RulesPanel'
import ScheduleInput from 'organization/Event/DashboardConfig/ComponentConfigPanel/ScheduleInput'
import {Rule} from 'Event/attendee-rules'

export function EmojiListConfig(
  props: ComponentConfigProps & {
    list: EmojiListProps
  },
) {
  const {showing, onClose} = props
  const {list} = props
  const [emojiWidth, setEmojiWidth] = useState(list.emojiWidth)
  const [emojis, setEmojis] = useState(list.emojis)
  const {remove: removeItem, update: updateItem} = useEditSidebarItem()
  const [rules, setRules] = useState<Rule[]>(list.rules || [])

  const {control, setValue, handleSubmit} = useForm()

  useEffect(() => {
    if (showing) {
      return
    }

    setEmojiWidth(list.emojiWidth)
    setEmojis(list.emojis)
  }, [showing, list])

  const save = () => {
    const data = {
      emojiWidth,
      emojis,
      rules,
    }

    updateItem(data)
    onClose()
  }

  useAutoUpdateSidebarItem({item: {emojiWidth, emojis}, when: showing})

  return (
    <ComponentConfig
      title="Emojis"
      showing={showing}
      onClose={onClose}
      onSubmit={handleSubmit(save)}
    >
      <SettingsPanel>
        <Settings
          emojiWidth={emojiWidth}
          setEmojiWidth={setEmojiWidth}
          emojis={emojis}
          setEmojis={setEmojis}
        />
      </SettingsPanel>
      <RulesPanel rules={rules} setRules={setRules}>
        <ScheduleInput setValue={setValue} control={control} values={list} />
      </RulesPanel>
      <Footer>
        <SaveButton type="submit" />
        <RemoveButton onClick={removeItem} />
      </Footer>
    </ComponentConfig>
  )
}
